import i18n from '../../../utils/i18n';
import Review1 from '~images/loggedout/review-images/review1.svg';
import Review2 from '~images/loggedout/review-images/review2.svg';
import Review3 from '~images/loggedout/review-images/review3.png';

export const getGradeMap = () => {
  return {
    k: i18n.t(`grader.K`),
    1: i18n.t(`grader.1st`),
    2: i18n.t(`grader.2nd`),
    3: i18n.t(`grader.3rd`),
    4: i18n.t(`grader.4th`),
    5: i18n.t(`grader.5th`),
    pk: i18n.t(`grader.Pre-K`)
  }
};

export const getData = () => {

  const reviewContentByGrade = {
    'pk': [
      {
        data: `SplashLearn is great for ${i18n.t(`practice`)} and supplement traditional school or home lessons`,
        name: 'Abdelhalim',
        image: 'https://cdn.splashmath.com/assets/casestudy/parents/abdelhalim-0f398c9393908f74f5e75c8d78f040dc8c2c32a7e750bca985686851067ab4d2.jpg',
        isCdn: true
      },
      {
        data: `Learning ${i18n.t(`Math`)} is so much easier with SplashLearn`,
        name: 'Glenndel Prochnow',
        image: 'https://cdn-skill.splashmath.com/uploads/testimonial/image/2/Glenndel-Prochnow.jpg',
        isCdn: true
      },
      {
        data: `${i18n.t(`Math`)} is now fun for my child`,
        name: 'Stacie Lewin',
        image: 'https://cdn-skill.splashmath.com/uploads/testimonial/image/3/Stacie-Lewin.jpg',
        isCdn: true
      }
    ],
    'k': [
      {
        data: `Learning ${i18n.t(`Math`)} is so much easier with SplashLearn`,
        name: 'Glenndel Prochnow',
        image: 'https://cdn-skill.splashmath.com/uploads/testimonial/image/2/Glenndel-Prochnow.jpg',
        isCdn: true
      },
      {
        data: `SplashLearn is great for ${i18n.t(`practice`)} and supplement traditional school or home lessons`,
        name: 'Abdelhalim',
        image: 'https://cdn.splashmath.com/assets/casestudy/parents/abdelhalim-0f398c9393908f74f5e75c8d78f040dc8c2c32a7e750bca985686851067ab4d2.jpg',
        isCdn: true
      },
      {
        data: `${i18n.t(`Math`)} is now fun for my child`,
        name: 'Stacie Lewin',
        image: 'https://cdn-skill.splashmath.com/uploads/testimonial/image/3/Stacie-Lewin.jpg',
        isCdn: true
      }
    ],
    '1': [
      {
        data: `Can't tell you enough how wonderful SplashLearn is`,
        name: 'Robyn Meeker',
        image: 'https://cdn.splashmath.com/assets/casestudy/parents/robyn1-9f60fe6902fd770315bf55c55150e66b219fadeb18b6cf4d61e44ebb8877e751.jpg',
        isCdn: true
      },
      {
        data: `Kid friendly easy to use. It really works on language and ${i18n.t(`math`)} at the same time`,
        name: 'Oliver',
        image: Review1
      },
      {
        data: 'You made learning fun and my kids love it we tried other learning products and they did not get into them. They love SplashLearn.',
        name: 'Ryder',
        image: Review2
      }
    ],
    '2': [
      {
        data: `Great tool for reinforcing old and introducing new ${i18n.t(`math`)} topics`,
        name: 'Lindsay Petersen',
        image: 'https://cdn.splashmath.com/assets/casestudy/parents/lindsay-87cc95f1cd3d1122c233cb14ff94c4f44bf6e22a1f1d721a83c944e90d5cb329.jpg',
        isCdn: true
      },
      {
        data: 'My daughter loves it and its very educational and helpful during this pandemic.',
        name: 'Amir',
        image: Review2
      },
      {
        data: 'Easy to use app with a great break down of all the required mathematic skills',
        name: 'Ava',
        image: Review1
      }
    ],
    '3': [
      {
        data: `Learning ${i18n.t(`Math`)} is so much easier with SplashLearn`,
        name: 'Glenndel Prochnow',
        image: 'https://cdn-skill.splashmath.com/uploads/testimonial/image/2/Glenndel-Prochnow.jpg',
        isCdn: true
      },

      {
        data: `My Grandaughter is learning pretty fast with the way the program teach is fun and understandable`,
        name: 'Julie',
        image: Review2
      },
      {
        data: `Grade appropriate lessons with cute animations and the parent dashboard.`,
        name: 'Oscar',
        image: Review1
      }

    ],
    '4': [
      {
        data: `Splash learning is a great way for young students to have fun while completing ${i18n.t(`math`)} problems.`,
        name: 'Alfredo Franci',
        image: Review2

      },
      {
        data: 'I would refer your program to everyone. My daughter did learn from this.',
        name: 'Jaydon Aminoff',
        image: Review2
      },
      {
        data: "My son's grades are higher!",
        name: 'Amy Jay',
        image: 'https://cdn.splashmath.com/web_ui/assets/images/loggedout/review-images/Parent_Amy@3x-4393420256a8287f334b1f0d87390ce8.png',
        isCdn: true
      }
    ],
    '5': [
      {
        data: `SplashLearn is great for ${i18n.t(`practice`)} and supplement traditional school or home lessons`,
        name: 'Abdelhalim',
        image: 'https://cdn.splashmath.com/assets/casestudy/parents/abdelhalim-0f398c9393908f74f5e75c8d78f040dc8c2c32a7e750bca985686851067ab4d2.jpg',
        isCdn: true

      },
      {
        data: 'As a parent its is very easy to navigate and my children enjoy using it.',
        name: 'Maria',
        image: Review1
      },
      {
        data: `Makes learning so much fun that my son wants to play ${i18n.t(`math`)}.`,
        name: 'Jesse',
        image: Review1
      }
    ]
  }

  return reviewContentByGrade;
}


export const t2GradeData = () => {

  const reviewContentByGrade = {
    'pk': [
      {
        data: `SplashLearn is great for ${i18n.t(`practice`)} and supplement traditional school or home lessons`,
        name: 'Abdelhalim',
        image: 'https://cdn.splashmath.com/assets/casestudy/parents/abdelhalim-0f398c9393908f74f5e75c8d78f040dc8c2c32a7e750bca985686851067ab4d2.jpg',
        isCdn: true
      },
      {
        data: `Learning ${i18n.t(`Math`)} is so much easier with SplashLearn`,
        name: 'Glenndel Prochnow',
        image: 'https://cdn-skill.splashmath.com/uploads/testimonial/image/2/Glenndel-Prochnow.jpg',
        isCdn: true
      },
      {
        data: `${i18n.t(`Math`)} is now fun for my child`,
        name: 'Stacie Lewin',
        image: 'https://cdn-skill.splashmath.com/uploads/testimonial/image/3/Stacie-Lewin.jpg',
        isCdn: true
      }
    ],
    'k': [
      {
        data: `Great to see my son so engaged in bite-sized learning games`,
        name: 'Brandon Wong',
        image: 'https://cdn-skill.splashmath.com/uploads/testimonial/image/2/Glenndel-Prochnow.jpg',
        isCdn: true
      },
      {
        data: `Perfect blend of useful screen-time & applying ${i18n.t(`math`)} skills`,
        name: 'Candice Thomas',
        image: 'https://cdn.splashmath.com/assets/casestudy/parents/abdelhalim-0f398c9393908f74f5e75c8d78f040dc8c2c32a7e750bca985686851067ab4d2.jpg',
        isCdn: true
      },
      {
        data: `My daughter loves the Live Classes. Helps her stay on track at school`,
        name: 'Gabby D.',
        image: 'https://cdn-skill.splashmath.com/uploads/testimonial/image/3/Stacie-Lewin.jpg',
        isCdn: true
      }
    ],
    '1': [
      {
        data: `Such a fun way to get my kids excited about learning`,
        name: 'April Bayot',
        image: 'https://cdn.splashmath.com/assets/casestudy/parents/robyn1-9f60fe6902fd770315bf55c55150e66b219fadeb18b6cf4d61e44ebb8877e751.jpg',
        isCdn: true
      },
      {
        data: `Great way to make study time at home effortless`,
        name: 'Anthony K.',
        image: Review1
      },
      {
        data: 'Progress reports keep me updated',
        name: 'Janessa Marcos',
        image: Review2
      }
    ],
    '2': [
      {
        data: `My daughter is learning on her own!`,
        name: 'Jamie E.',
        image: 'https://cdn.splashmath.com/assets/casestudy/parents/lindsay-87cc95f1cd3d1122c233cb14ff94c4f44bf6e22a1f1d721a83c944e90d5cb329.jpg',
        isCdn: true
      },
      {
        data: 'Amazed at the progress my sons are making',
        name: 'Annie R.',
        image: Review2
      },
      {
        data: "My son's confidence is increasing with Live Classes",
        name: 'Nick Urena',
        image: Review1
      }
    ],
    '3': [
      {
        data: `Such a fun way to get my kids excited about learning`,
        name: 'April Bayot',
        image: 'https://cdn-skill.splashmath.com/uploads/testimonial/image/2/Glenndel-Prochnow.jpg',
        isCdn: true
      },

      {
        data: `Helped my son get over his multiplication fear`,
        name: 'Marianne B.',
        image: Review2
      },
      {
        data: `Fantastic teachers…my daughter loves every class`,
        name: 'Janet M.',
        image: Review1
      }

    ],
    '4': [
      {
        data: `Such a fun way to get my kids excited about learning`,
        name: 'April Bayot',
        image: Review2

      },
      {
        data: "Love the guided activities & games. My son's grades are higher!",
        name: 'Amy Jay',
        image: Review2
      },
      {
        data: "I definitely recommend the Live Classes",
        name: 'Ben C.',
        image: 'https://cdn.splashmath.com/web_ui/assets/images/loggedout/review-images/Parent_Amy@3x-4393420256a8287f334b1f0d87390ce8.png',
        isCdn: true
      }
    ],
    '5': [
      {
        data: `Amazed at the progress my sons are making`,
        name: 'Annie R.',
        image: 'https://cdn.splashmath.com/assets/casestudy/parents/abdelhalim-0f398c9393908f74f5e75c8d78f040dc8c2c32a7e750bca985686851067ab4d2.jpg',
        isCdn: true

      },
      {
        data: 'My daughter is doing better at school',
        name: 'David B.',
        image: Review1
      },
      {
        data: `My son is so upbeat after his class`,
        name: 'Cindy H.',
        image: Review1
      }
    ]
  }

  return reviewContentByGrade;
}

